var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import RowNumber from './RowNumber';
var Row = /** @class */ (function (_super) {
    __extends(Row, _super);
    function Row() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Row.prototype.render = function () {
        var _a = this.props, visible = _a.visible, rowNumber = _a.rowNumber, isSelected = _a.isSelected, offset = _a.offset, height = _a.height;
        var className = 'seat-picker__row' +
            (isSelected
                ? ' seat-picker__row--selected'
                : ' seat-picker__row--enabled');
        return (React.createElement("div", { className: className, style: { height: "".concat(height, "px"), marginLeft: "".concat(offset || 2, "px") } },
            React.createElement(RowNumber, { rowNumber: rowNumber, visible: visible }),
            this.props.children));
    };
    return Row;
}(Component));
export default Row;



//////////////////
// WEBPACK FOOTER
// ./src/components/Seatmap/SeatPicker/Row.tsx
// module id = 1271
// module chunks = 0